import React from 'react';
import { Menu } from 'evergreen-ui';

const MoleculeMenu = ({ onEditClick, onDeleteClick }: any) => {
  return (
    <Menu>
      <Menu.Group>
        <Menu.Item onSelect={onEditClick}>Edit molecule</Menu.Item>
      </Menu.Group>
      <Menu.Divider />
      <Menu.Group>
        <Menu.Item intent="danger" onSelect={onDeleteClick}>
          Delete molecule
        </Menu.Item>
      </Menu.Group>
    </Menu>
  );
};

export default MoleculeMenu;
